import { render, staticRenderFns } from "./EditEmployeeFooter.vue?vue&type=template&id=7b5152c7&scoped=true&"
import script from "./EditEmployeeFooter.vue?vue&type=script&lang=ts&"
export * from "./EditEmployeeFooter.vue?vue&type=script&lang=ts&"
import style0 from "./EditEmployeeFooter.vue?vue&type=style&index=0&id=7b5152c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5152c7",
  null
  
)

export default component.exports